import React from "react";

import { Select } from "components/forms";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";

import { FormValues } from "../schemas";

interface Props {
  name: "interest_rate_fixing" | "pik_rate_fixing";
  formik: FormikProps<FormValues>;
  label?: string;
  disabled?: boolean;
  size?: "small" | "medium";
}

export const RateFixingTypeSelect: React.FC<Props> = ({ name, formik, label, disabled = false, size }) => {
  const { t } = useTranslation("debt");

  const items = [
    { key: "none", value: "", text: "" },
    { key: "in_arrears", value: "in_arrears", text: t("rateFixing.inArrears") },
    { key: "in_advance", value: "in_advance", text: t("rateFixing.inAdvance") },
    { key: "compounded", value: "compounded", text: t("rateFixing.compounded") },
  ];

  return (
    <Select
      disabled={disabled}
      name={name}
      label={label ?? t("interestSection.rateFixing")}
      value={formik.values[name] || ""}
      variant="outlined"
      fullWidth
      size={size}
      items={items}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] ? (formik.errors[name] as string) : undefined}
      onChange={formik.handleChange}
    />
  );
};
